import '@aws-amplify/ui-react/styles.css';
import './fonts.css';
import CssReset from './reset';
import CssLogin from './login';

function CommonStyles(): JSX.Element {
  return (
    <>
      <CssReset />
      <CssLogin />
    </>
  );
}

export default CommonStyles;
